import { request } from '@/common/utils/request'

export function fetchTabAuth(params) {
  return request
    .get({
      url: 'feidian.bdapp.bizopp.getTabAuth',
      params,
    })
    .then(res => res.data)
}

// 获取搜索结果
export function fetchGasSearchResultList(params) {
  return request.post({
    url: 'feidian.gas.bizopp.bdapp.getSearchResultList',
    params,
  })
}

// 获取搜索商机sug
export function fetchBizoppSugList(params) {
  return request.get({
    url: 'feidian.gas.bizopp.bdapp.getNameSug',
    params,
  })
}
